import EmberRouter from '@ember/routing/router';
import { service } from '@ember/service';

import config from 'register-partners-js/config/environment';

export default class Router extends EmberRouter {
  @service segment;

  location = config.locationType;
  rootURL = config.rootURL;

  constructor() {
    super(...arguments);

    this.on('routeDidChange', this.trackPageView);
  }

  trackPageView() {
    this.segment.page();
  }
}

/* oxlint-disable array-callback-return */
Router.map(function () {
  this.route('welcome', { path: ':redirection_id' }, function () {
    this.route('consent');
    this.route('email-confirmation');
    this.route('not-owner');
    this.route('not-eligible');
    this.route('password-creation');
  });

  this.route('login');

  this.route('authenticated', { path: '' }, function () {
    this.route(
      'registration',
      { path: 'registrations/:registration_id', resetNamespace: true },
      function () {
        this.route('price-plans', function () {
          this.route('offers');
          this.route('overviews');
        });
        this.route('order-summary');
        this.route('payment');
        this.route('payment-error', { path: '/payment/error' });
        this.route('almost-ready');
        this.route('kyc');
        this.route('kyc-success');
        this.route('start');
        this.route('phone-number');
        this.route('business-finances');
        this.route('credentials-success');
        this.route('nature-of-ops');
        this.route('next-steps');
        this.route('pending-contract');
      }
    );
    this.route('registrations', { resetNamespace: true }, function () {
      this.route('already-created', {
        path: 'already-created/:organization_id',
      });
    });
  });

  this.route('react', { path: '/*path' });
  this.route('next-steps');
});
